
import { defineComponent } from 'vue';
import { useDialogPluginComponent } from 'quasar';
export default defineComponent({
  name: 'WarningDialog',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: false,
      default: ''
    },
    icon: {
      type: String,
      required: false,
      default: 'fi-triangle-warning'
    }
  },
  setup() {
    const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent();

    return {
      dialogRef,
      onDialogHide,
      onDialogOK
    };
  }
});
